module.exports = __webpack_public_path__ + "img/49812ee83e3e3001ba5f2f0cf7ca313d.svg";